<template>
  <div class="dashboard-section">
    <div
      v-if="title"
      class="dashboard-section__title"
    >
      {{ title }}
    </div>
    <div
      v-if="description"
      class="dashboard-section__description"
    >
      {{ description }}
    </div>
    <div class="dashboard-section__content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'DashboardSection',
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    description: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.dashboard-section {
  margin-bottom: 28px;

  &__title {
    font-size: 0.875rem;
    font-weight: 700;
    color: var(--v-textPrimary-base);
    margin-bottom: 4px;
  }

  &__description {
    font-size: 0.8rem;
    color: var(--ds-color-black-055);
    margin-bottom: 14px;
  }

  &__content {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
